import './App.css';
import Hero from './components/hero';
import Features from './components/features';
import Motive from './components/motive'
import Points from './components/points';
import PreRegister from './components/preregister';
import Footer from './components/footer'
import Header from './components/header'
import Journey from './components/journey'
import { Routes, Route } from 'react-router-dom';

function Home() {
  return (
    <div className="App">
      <main>
        <Header />
        <Hero />
        <Features />
        <Motive />
        <Points />
        <PreRegister />
        <Footer />
      </main>
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/journey" element={<Journey />} />
    </Routes>
  );
}

export default App;
